var AdventureConst = {
    // -- 状态(0:未开始 1:可探索 2:探索中 3:已完成)
    status: {
        lock: 0,
        can_open: 1,
        open: 2,
        over: 3,
    }
}

module.exports = AdventureConst